import React, { useEffect, useState } from "react";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";
import { faBarsFilter } from "@fortawesome/pro-solid-svg-icons";
import { TurnrButton } from "~/components/buttons/TurnrButton";
import { TurnrCardContent } from "~/components/card/TurnrCard.jsx";
import SearchInput from "~/components/input/inputs/SearchInput.jsx";
import LineDivider from "rylak-common/src/components/divider/LineDivider";
import styles from "./SearchAndFilterComponent.module.scss";

export default function SearchAndFilterComponent(props) {
    const { leftComponents, rightComponents, filterComponents, searchComponent, searchString, onSearchChange, hasAnyFilterValue, onReset, dotsMenu, children } = props;

    const [showFilters, setShowFilters] = useState(hasAnyFilterValue);

    function localOnReset() {
        setShowFilters(false);
        // onSearchChange("");
        onReset();
    }

    useEffect(() => {
        if (hasAnyFilterValue) {
            setShowFilters(true);
        }
    }, [hasAnyFilterValue]);

    const hasFilterComponents = filterComponents?.length > 0 || children;
    const hasLeftComponents = leftComponents?.length > 0;
    const hasRightComponents = rightComponents?.length > 0;

    return (
        <>
            <TurnrCardContent>
                <TurnrGrid container spacing={1} justifyContent={"space-between"} alignItems={"center"} wrap={"nowrap"}>
                    <TurnrGrid container item spacing={1} alignItems={"center"}>
                        <TurnrGrid item xs={12} lg={4} xl={3}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                {searchComponent ? searchComponent : <SearchInput value={searchString} onChange={onSearchChange} />}
                                {dotsMenu && <div className={styles["dots-menu-mobile-view"]}>{dotsMenu}</div>}
                            </div>
                        </TurnrGrid>

                        <TurnrGrid item xs={12} sm={hasRightComponents ? 12 : 6} lg={8} xl={9}>
                            <TurnrGrid container spacing={1} className={styles["filter-wrapper"]}>
                                {hasFilterComponents && (
                                    <TurnrGrid item xs={12} sm={hasRightComponents ? 6 : 12} lg={"auto"}>
                                        {!showFilters && (
                                            <TurnrButton variant={"text"} size="small" fullWidth={true} fontAwesomeIcon={faBarsFilter} onClick={() => setShowFilters(true)}>
                                                Show Filters
                                            </TurnrButton>
                                        )}
                                        {showFilters && (
                                            <TurnrButton variant={"text"} size={"small"} fullWidth={true} fontAwesomeIcon={faBarsFilter} onClick={localOnReset}>
                                                Reset filters
                                            </TurnrButton>
                                        )}
                                    </TurnrGrid>
                                )}
                                {hasLeftComponents && (
                                    <TurnrGrid item xs={12} sm={6} lg={"auto"}>
                                        <div
                                            style={{
                                                display: "flex",
                                                gridGap: "10px",
                                            }}
                                        >
                                            {leftComponents.map((component) => {
                                                return component;
                                            })}
                                        </div>
                                    </TurnrGrid>
                                )}
                                {(hasRightComponents || dotsMenu) && (
                                    <TurnrGrid
                                        item
                                        xs={12}
                                        sm={!hasFilterComponents && !hasLeftComponents ? 12 : 6}
                                        lg={"auto"}
                                        style={{
                                            marginLeft: "auto",
                                        }}
                                        className={!hasRightComponents && styles["dots-menu-pc-view"]}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                gridGap: "10px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {rightComponents?.map((component) => {
                                                return component;
                                            })}
                                            {dotsMenu && <div className={styles["dots-menu-pc-view"]}>{dotsMenu}</div>}
                                        </div>
                                    </TurnrGrid>
                                )}
                            </TurnrGrid>
                        </TurnrGrid>
                    </TurnrGrid>
                </TurnrGrid>
            </TurnrCardContent>

            <div style={{ display: (!showFilters || !hasFilterComponents) && "none" }}>
                <LineDivider />
                <TurnrCardContent>
                    {filterComponents && (
                        <TurnrGrid container spacing={1}>
                            {filterComponents
                                ?.filter((c) => c)
                                .map((c, index) => {
                                    return (
                                        <TurnrGrid
                                            item
                                            xs={12}
                                            sm={6}
                                            lg={3}
                                            xl={2}
                                            // md={"auto"}
                                            key={index}
                                        >
                                            {c}
                                        </TurnrGrid>
                                    );
                                })}
                        </TurnrGrid>
                    )}
                    {children}
                </TurnrCardContent>
            </div>
        </>
    );
}
